import { Box, MenuItem, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useSheetMenu } from "../hooks/useSheetMenu";

export function SheetSelection({
  sheetIds = [],
  fieldName = "sheetIds",
  fieldCount = 1,
  fieldLabels,
  onChange,
  sheetData,
  ...rest
}) {
  const { t } = useTranslation();
  const menuList = useSheetMenu(sheetData, sheetIds);

  return Array.from({ length: fieldCount }, (_, i) => (
    <Box key={i} mb="15px" display="flex" justifyContent="center">
      <TextField
        name={`${fieldName}[${i}]`}
        value={sheetIds[i] || ""}
        select
        variant="outlined"
        fullWidth
        label={
          fieldLabels
            ? fieldLabels[i]
            : t("tool.addEdit.sequence", `Sequence: {{sequence}}`, {
                sequence: i + 1,
              })
        }
        onChange={e => onChange?.(e, i)}
        {...rest}
      >
        <MenuItem value="">
          <em>None</em>
        </MenuItem>
        {menuList}
      </TextField>
    </Box>
  ));
}
